import { Stack } from "PFComponents/containers";

import { WizardActiveStep } from "./parts/wizard_active_step/wizard_active_step";
import { WizardFooter } from "./parts/wizard_footer/wizard_footer";
import { WizardHeader } from "./parts/wizard_header/wizard_header";
import { WizardProgress } from "./parts/wizard_progress/wizard_progress";
import css from "./roll_forward_wizard.module.scss";
import { RollForwardWizardInitialState, RollForwardWizardStoreProvider } from "./roll_forward_wizard_store";

type RollForwardWizardProps = {
  initialState?: RollForwardWizardInitialState;
};

export const RollForwardWizard = ({ initialState }: RollForwardWizardProps) => (
  <RollForwardWizardStoreProvider initialState={initialState}>
    <Stack as="article" gap="spacingLg" className={css.body}>
      <WizardHeader />
      <WizardProgress />
      <WizardActiveStep />
      <WizardFooter />
    </Stack>
  </RollForwardWizardStoreProvider>
);
